export default __webpack_public_path__ + "static/4-91f2e6128ab3ce68d6f1eccbc891fe39.webp";